import type { Airline } from "@/app/lib/types/interfaces";
import { Avatar, Checkbox, Divider } from "@mui/material";
import { useTranslations } from "use-intl";
import type { ChangeEvent } from "react";

type Props = {
  airlines: Airline[];
  selectedAirlines: string[];
  userManuallySelectedAllAirlines: boolean;
  onSingleAirlineChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    airline: Airline,
  ) => void;
};

export const AirlinesFilter = ({
  airlines,
  selectedAirlines,
  userManuallySelectedAllAirlines,
  onSingleAirlineChange,
}: Props) => {
  const t = useTranslations();

  const areAllAirlinesSelected = selectedAirlines?.length === airlines.length;

  return (
    <ul>
      {airlines.map((airline) => (
        <li key={airline.name}>
          <label className="my-2 flex justify-between">
            <span className="flex items-center">
              <Avatar
                key={airline.name}
                alt={t("flights.airlineLogoAlt", { airline: airline.name })}
                sx={{
                  width: 32,
                  height: 32,
                }}
                src={airline.logoUrl}
              >
                {airline.name?.charAt(0) || ""}
              </Avatar>
              <span className="mr-2 ml-2 font-normal">{airline.name}</span>
            </span>

            <Checkbox
              checked={
                selectedAirlines?.includes(airline.code) &&
                (airlines.length === 1 ||
                  userManuallySelectedAllAirlines ||
                  !areAllAirlinesSelected)
              }
              onChange={(e, checked) =>
                onSingleAirlineChange(e, checked, airline)
              }
              sx={{ padding: "6px" }}
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
